import { Route } from 'types/route.type';
import EditMarketProfiles from './edit-market-profiles';

export const routes: Route[] = [
  {
    path: '/profiles-strategies/market',
    component: EditMarketProfiles,
    id: 'profilesStrategies.createProfiles.title',
  },
];
